module.exports = require("redux");


/*****************
 ** WEBPACK FOOTER
 ** external "redux"
 ** module id = 47
 ** module chunks = 0
 **/